import React, { Component } from "react";
import Logout from "../assets/logout.svg";
import Back from "../assets/back.svg";
import messages from "../assets/messages.png";
import DashboardItem from "../components/DashboardItem";
import { isUser, LogoutFunction } from "../static.js";
import Tooltip from "@mui/material/Tooltip";

export default class AdminDashboard extends Component {
  onBack() {
    this.props.history.push("/Restaurants");
  }

  onMessagePatterns() {
    this.props.history.push("/Admin/MessagePatterns");
  }

  onLogout() {
    LogoutFunction();
  }

  render() {
    return (
      <div className="Login">
        <div className="header">
          <div
            onClick={this.onBack.bind(this)}
            className="linkStyle backButton"
          >
            <img
              src={Back}
              alt=""
              className="backButtonIcon"
              style={{ transform: "rotate(180deg)" }}
            />
            لیست رستوران‌ها
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "fit-content",
              alignItems: "center",
            }}
          >
            <Tooltip title="خروج">
              <div
                onClick={this.onLogout.bind(this)}
                className="linkStyle backButton"
                // data-tip="خروج"
                // data-place="bottom"
              >
                <img src={Logout} alt="" className="backButtonIcon" />
              </div>
            </Tooltip>
          </div>
        </div>
        <div style={{ minHeight: "20px", height: "3vh", maxHeight: "40px" }} />
        <div className="LoginContent">
          <div className="RestaurantsListTitle">پنل مدیریت ادمین سپند</div>
          {/* <div className="RestaurantsListSubTitle">{this.state.resDescription}</div> */}
        </div>
        <div style={{ minHeight: "30px", height: "8vh", maxHeight: "60px" }} />
        <div className="dashboardContent">
          <div
            style={{
              flex: "1",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="menu-grid">
              <DashboardItem
                img={messages}
                title="مدیریت الگوی پیام‌ها"
                onClick={this.onMessagePatterns.bind(this)}
              />
            </div>
          </div>
          <div style={{ flex: "2" }} />
        </div>
        <div style={{ minHeight: "100px" }} />
      </div>
    );
  }
}
